var cartInit = function () {
    $(document).ready(function () {
        $('.payment-type-selection .custom-control-input:checked').trigger('change');
    });

    var el_payment_methods = $('.payment-form [name="payment_method_id"]');
    if (el_payment_methods.length) {
        el_payment_methods.trigger('change');
    }

    var el_threeDModal = $('#threeDModal');
    var el_iframe = el_threeDModal.find('.modal-body iframe');
    el_iframe.addClass('visible');
    $('.payment-form').on('submit', function (e) {
        var el_form = $(this),
        el_submit_button = el_form.find('[type=submit]');
        var iframeDocument = el_iframe[0].contentWindow.document;

        var el_cc = $(this).find('[name="payment_method_id"][value="4"]:checked,[name="payment_method_id"][value="13"]:checked');

        App.prototype.loadingButton(el_submit_button, 0);

        if (el_cc.length) {
            e.preventDefault();

            App.prototype.manuallySetIntlTelInputValueForAjax();

            var data = el_form.serialize();

            $.ajax({
                type: "POST",
                url: el_form.attr('action'),
                data: data,
                success: function (response) {
                    iframeDocument.open();
                    iframeDocument.write(response);
                    iframeDocument.close();

                    el_threeDModal.modal('show');
                },
                error: function (response) {

                    let message = 'Sipariş sırasında bir hata oluştu. Lütfen sayfayı yenileyerek tekrar deneyiniz.';

                    if (response.responseJSON !== undefined && response.responseJSON.message !== undefined){
                        message = response.responseJSON.message;
                    }

                    App.prototype.notificationError(message);

                },
                complete: function (){
                    App.prototype.loadingButton(el_submit_button, 1);
                }
            });
        }
    });

    el_iframe.on('load', function (e) {

        var wrap = $(this)[0].contentWindow.document.querySelector('.threeDSuccess-message');

        if (wrap){
            // console.log(wrap.dataset.empty)

            $.ajax({
                type: "GET",
                url: wrap.dataset.empty,
                success: function (response) {
                    setTimeout(function () {
                        location.href = wrap.dataset.redirect;
                    }, 2000);
                },
                error: function (response) {

                }
            });
        }
    });

    setInterval(function () {

        var wrap = el_iframe[0].contentWindow.document.querySelector('.async-threeDSuccess-message');

        if (wrap){

            if (wrap.querySelector("#success").style.display === "block"){

                $.ajax({
                    type: "GET",
                    url: wrap.dataset.empty,
                    success: function (response) {
                        setTimeout(function () {
                            location.href = wrap.dataset.redirect;
                        }, 2000);
                    },
                    error: function (response) {

                    }
                });

            }else{



            }

        }

    }, 1000);

    $('input[name$="delivery_type_id"]').on('click', function () {
        const type_id = $(this).val(),
        cityDistrictElements = $('[name="city_id"],[name="district_id"]');

        App.prototype.getCart({
            delivery_type_id: type_id,
            payment_method_id: $('input[name$="payment_method_id"]:checked').val(),
            installment_amount: $('input[name="installment_amount"]:checked').val()
        });

        if (type_id != 2) {
            $('#address').prop('required', true);
            cityDistrictElements.prop('required', true);
            $('#address-container').removeClass('d-none');
            cityDistrictElements.parents('.location-row').removeClass('d-none');
        }else{
            $('#address-container').addClass('d-none');
            cityDistrictElements.parents('.location-row').addClass('d-none');
            $('#address').prop('required', false);
            cityDistrictElements.prop('required', false);
        }
    });

    $('input[name$="payment_method_id"]').on('click', function () {
        const type_id = $(this).val();
        App.prototype.getCart({
            delivery_type_id: $('input[name$="delivery_type_id"]:checked').val(),
            payment_method_id: type_id
        });
    });
};
App.prototype.pageDetector('basket-page', cartInit);
